/*
 * (c) copyright 2021 International Road Dynamics Inc. and related companies.
 * All rights reserved.
 * Copyright as an unpublished work.
 *
 * This file contains confidential information of International
 * Road Dynamics Inc. and related companies, and should be treated as proprietary
 * and confidential.
 *
 * The use, copying, disclosure or modification of the
 * programs and/or source code is prohibited unless
 * otherwise provided for in the license or confidentiality
 * agreements.
 *
 * Any copy must contain this copyright notice.
 */

export const SiteStatuses = {
  LIVE: 'Operational',
  MONITOR: 'Monitoring',
  NON_FUNCTIONAL: 'Non-functional',
  CONSTRUCTION: 'Under Construction',
  DECOMMISSIONED: 'Decommisioned'
}

export const SiteTypes = {
  WIM: 'WIM',
  CTM: 'CTM',
  EVC: 'EVC'
}

export const ExternalUrlTypes = {
  ACYCLICA: 'acyclica',
  VWS: 'vws'
}

export const ExternalUrlParameterTypes = {
  LABEL_SUFFIX: 'label_suffix'
}
